/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useEffect, useState } from "react";
import SearchForm from "../SearchForm/SearchForm";
import styles from "./Popover.styles";
import { EVENT_NAME } from "../../../../contants";

const DEFAULT_WIDTH = 633;
const DEFAULT_HEIGHT = 500;

function Popover({ heading, children, minWidth, minHeight }) {
  const [open, setOpen] = useState(false);

  const toggle = () => setOpen((prev) => !prev);

  useEffect(() => {
    document.addEventListener(EVENT_NAME, () => setOpen(false));
    return () => {
      document.addEventListener(EVENT_NAME, () => setOpen(false));
    };
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.title} onClick={toggle}>
        {heading}
      </div>
      <div style={!open ? styles.hide : {}}>
        <div style={styles.placeholder} onClick={toggle} />
        <div
          style={{
            ...styles.main,
            minWidth: minWidth ?? DEFAULT_WIDTH,
            minHeight: minHeight ?? DEFAULT_HEIGHT,
          }}
        >
          <SearchForm onClose={toggle} heading={heading}>
            {children}
          </SearchForm>
        </div>
      </div>
    </div>
  );
}

export default Popover;
